// @flow
import React from "react"
import { Container } from "componentsStyled/Layout/Containers"
import { PageTitle } from "componentsStyled/Typography/Titles"
import withQuery from "hoc/withQuery"
import { compose, type HOC } from "recompose"
import { nearbyStoresQuery } from "data/affiliate/graphql"
import AffiliateList from "components/AffiliateList"
import { WhiteWrap}  from "componentsStyled/Layout/WhiteWrap"
import type { Location } from "data/app/types"

const SectionTopSellers = ({ data }) => (
  <React.Fragment>
    <WhiteWrap>
      <Container>
        <PageTitle>
          Top Locations Nearby
        </PageTitle>
        <AffiliateList affiliates={data} />
      </Container>
    </WhiteWrap>
  </React.Fragment>
)

type Outter = {|
  geolocations: ?Location[],
|}

const enhancer: HOC<*, Outter> = compose(
  withQuery(nearbyStoresQuery, {
    noEmpty: true,
    variables: ({ geolocations }) => ({
      limit: 4,
      discountId: undefined,
      locationIds: geolocations ? geolocations.map(geo => geo.id) : undefined,
      productGroups: undefined,
    }),
  }),
)

export default enhancer(SectionTopSellers)



// WEBPACK FOOTER //
// ./src/pages/Home/SectionTopSellers/index.js